const colors = {
    appBarBackground: '#F8F8F8',
    lightShadow: '#F0F0F0',
    black: '#000000',
    button: '#DD1459',
    darkGray: '#2e2d30',
    focusedField: '#913DD8',
    main: '#DD1459',
    lightMain: '#DD1459',
    lighterMain: '#DD1459',
    lightBorderGray: '#E1E1E1',
    lightGray: '#F3F0F0',
    lightDarkerGray: '#BFBFBF',
    darkIcon: '#263238',
    labelColor: '#929292',
    lightWarning: 'rgba(255, 0, 0, 0.20)',
    midGray: '#5a5a5c',
    midDarkerGray: '#737373',
    warning: '#FF0000',
    white: '#FFFFFF',
}

export default colors
